import ListViewSwitch from "components/ListViewSwitch";
import SearchInput from "components/input/SearchInput";
import { ListFilterParams } from "components/typings";
import { TaskBase } from "pages/project/common/taskBase.typing";
import { cn } from "utils/ui";
import TaskBaseSortByDropdown from "./TaskBaseSortByDropdown";
import { useTranslation } from "react-i18next";
import SwitchButton from "components/buttons/SwitchButton";

interface Props {
  isDetailOpen: boolean;
  params: ListFilterParams<TaskBase>;
  onChange: (params: ListFilterParams<TaskBase>) => void;
  isUserSupplier: boolean;
}

const TaskBaseListFilter = ({ isDetailOpen, params, onChange, isUserSupplier }: Props) => {
  const { t } = useTranslation();
  const { term, sortBy, view, sortDirection, isGrouped = false } = params;
  const handleOnChange = (fromParams: Partial<ListFilterParams<TaskBase>>) => {
    onChange({ ...params, ...fromParams });
  };

  return (
    <div className="text-color-base bg-color-base mb-4 flex flex-row items-start rounded-md border border-slate-200 p-4 dark:border-slate-800 sm:items-center">
      <div className="flex-1">
        <div className="flex max-w-md flex-col sm:flex-row sm:items-center sm:space-x-4">
          <div className="mb-4 flex-1 sm:mb-0">
            <SearchInput onSearch={(fromTerm) => handleOnChange({ term: fromTerm })} term={term} />
          </div>
          <div
            className={cn("max-w-fit", view === "card" ? "" : isDetailOpen ? "block 2xl:hidden" : "block xl:hidden")}
          >
            <TaskBaseSortByDropdown
              onSort={(fromSortBy, fromSortDirection) =>
                handleOnChange({ sortBy: fromSortBy, sortDirection: fromSortDirection })
              }
              sortBy={sortBy}
              sortDirection={sortDirection}
              isUserSupplier={isUserSupplier}
            />
          </div>
        </div>
      </div>
      <div className="hidden lg:flex lg:items-center lg:space-x-4">
        <div className="ml-4">
          <SwitchButton
            label={t("offer.group")}
            checked={isGrouped}
            toggleCheck={(grouped) => handleOnChange({ isGrouped: grouped })}
          />
        </div>

        <ListViewSwitch
          view={view}
          onSwitchView={(fromView) => {
            handleOnChange({ view: fromView });
            // When switching to card view, disable grouping
            if (fromView === "card" && isGrouped) {
              handleOnChange({ view: fromView, isGrouped: false });
            }
          }}
        />
      </div>
    </div>
  );
};

export default TaskBaseListFilter;
